import { API } from "src/util/api";
import { call, put, takeLatest } from "redux-saga/effects"
import { jobsheetTatActions } from "./actionTypes";
import { getJobPrefixExcelError, getJobPrefixExcelSuccess, getJobsheetCourierTypeOptionsError, getJobsheetCourierTypeOptionsSuccess } from "./action";


//worker function

//get method

function* downloadJobPrefixData(action: any) {
  try {
    const response: Promise<any> = yield call(API.sendMailJobPrefixExcel, action?.prefix);
    yield put(getJobPrefixExcelSuccess(response));
  } catch (error) {
    yield put(getJobPrefixExcelError(error));
  }
}

function* getCourierTypeOptions(action: any) {
  try {
    const response: Promise<any> = yield call(API.getCourierTypeOptionsApi);
    yield put(getJobsheetCourierTypeOptionsSuccess(response));
  } catch (error) {
    yield put(getJobsheetCourierTypeOptionsError(error));
  }
}

//watcher function

function* jobsheetTatSaga() {
  yield takeLatest(jobsheetTatActions.DOWNLOAD_JOB_PREFIX_EXCEL_LOADING, downloadJobPrefixData)
  yield takeLatest(jobsheetTatActions.GET_JOBSHEET_COURIER_OPTION_LOADING, getCourierTypeOptions)
}


export default jobsheetTatSaga;